import YouTube from "@vip30/react-youtube";
import { useCallback, useEffect, useState } from "react";

type Parameters = {
  adsManager?: google.ima.AdsManager;
  isAdStarted?: boolean;
};

export const useCheckManualPauseEffect = (parameters: Parameters) => {
  const { adsManager, isAdStarted } = parameters;
  const [onMouseOvered, setOnMouseOvered] = useState(false);
  const [isManualPaused, setIsManualPaused] = useState(false);

  const handleOnAdPaused = useCallback(() => {
    setIsManualPaused(onMouseOvered);
  }, [onMouseOvered]);

  const handleOnAdResumed = useCallback(() => {
    setIsManualPaused(false);
  }, []);

  useEffect(() => {
    if (!adsManager) return;
    adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, handleOnAdPaused);
    adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, handleOnAdResumed);
    return () => {
      adsManager.removeEventListener(google.ima.AdEvent.Type.PAUSED, handleOnAdPaused);
      adsManager.removeEventListener(google.ima.AdEvent.Type.RESUMED, handleOnAdResumed);
    };
  }, [adsManager, handleOnAdPaused, handleOnAdResumed]);

  const handleOnYoutubePlayerStateChange = useCallback(
    ({ data }: { data: number }) => {
      if (isAdStarted) return;
      switch (data) {
        case YouTube.PlayerState.PAUSED:
          handleOnAdPaused();
          break;
        case YouTube.PlayerState.PLAYING:
          handleOnAdResumed();
          break;
      }
    },
    [handleOnAdPaused, handleOnAdResumed, isAdStarted],
  );

  const handleOnYoutubeInteractStart = useCallback(() => {
    setOnMouseOvered(true);
  }, []);

  const handleOnYoutubeInteractEnd = useCallback(() => {
    setOnMouseOvered(false);
  }, []);

  return {
    handleOnYoutubeInteractEnd,
    handleOnYoutubeInteractStart,
    handleOnYoutubePlayerStateChange,
    isManualPaused,
  };
};
